export enum SogButtonStyle{
  Default,
  Primary,
  Success,
  Info,
  Warning,
  Danger,
  Link
}
